import { BLOCK_DELIMITER } from '../../utils/constants';
import insertBlock from './insertBlock';
import insertText from './insertText';
export default function insertOperation(editor, _ref) {
  var insert = _ref.insert,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? {} : _ref$attributes;

  if (insert === BLOCK_DELIMITER) {
    return insertBlock(editor, attributes);
  } else {
    return insertText(editor, insert, attributes);
  }
}